import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_CURRENT_URL: z.string().url(),
    VITE_SERVER_URL: z.string().url(),
    VITE_APPLICANT_URL: z.string().url(),
    VITE_PDF_SERVER_URL: z.string().url(),
    VITE_WEBHOOKS_URL: z.string().url(),
    VITE_CAREER_URL: z.string().url(),
    VITE_API_URL: z.string().url(),
    VITE_STORAGE_BUCKET: z.string(),
    VITE_VERSION: z.string(),
    // Where customer sites load the ad list widget from. Defaults to
    // VITE_SERVER_URL + /widget/ad-list.js; set it to keep snippets on a
    // stable domain that points at ats-backend.
    VITE_AD_LIST_WIDGET_URL: z.string().url().optional(),
    VITE_NODE_ENV: z.string().default("development"),
    /**
     * The public user manual (apps/manual). The support popover and the user menu link to it.
     * A missing or malformed value falls back to help.cruitive.com instead of failing the whole env check.
     */
    VITE_MANUAL_URL: z.string().url().catch("https://help.cruitive.com"),
  },
  runtimeEnv: {
    VITE_CURRENT_URL: import.meta.env.VITE_CURRENT_URL as string,
    VITE_SERVER_URL: import.meta.env.VITE_SERVER_URL as string,
    VITE_APPLICANT_URL: import.meta.env.VITE_APPLICANT_URL as string,
    VITE_PDF_SERVER_URL: import.meta.env.VITE_PDF_SERVER_URL as string,
    VITE_WEBHOOKS_URL: import.meta.env.VITE_WEBHOOKS_URL as string,
    VITE_CAREER_URL: import.meta.env.VITE_CAREER_URL as string,
    VITE_API_URL: import.meta.env.VITE_SERVER_URL as string,
    VITE_STORAGE_BUCKET: import.meta.env.VITE_STORAGE_BUCKET as string,
    VITE_VERSION: import.meta.env.VITE_VERSION as string,
    VITE_AD_LIST_WIDGET_URL: import.meta.env.VITE_AD_LIST_WIDGET_URL as
      | string
      | undefined,
    VITE_NODE_ENV: process.env.NODE_ENV as string,
    VITE_MANUAL_URL: import.meta.env.VITE_MANUAL_URL as string | undefined,
  },
});
